<template>
  <aside
    class="lightbox"
    :for="name"
    :class="getLightboxClasses"
    v-show="shouldShowLightbox"
    @mousedown="$root.lightboxClick($event)"
  >
    <template v-if="layout">
      <div v-if="layout === 'split-view'" class="lightbox__form-container">
        <div class="lightbox__image" :class="getImageClasses"></div>
        <div class="lightbox__form">
          <slot></slot>
        </div>
      </div>
      <div
        v-if="layout === 'reverse-split-view'"
        class="lightbox__form-container"
      >
        <div class="lightbox__form">
          <slot></slot>
        </div>
        <div class="lightbox__image" :class="getImageClasses"></div>
      </div>
    </template>

    <slot v-else> </slot>
  </aside>
</template>

<script>
import cookies from 'js-cookie';
import countryCode from '../../../analytics/country-code';
import { shouldAllowPromoForCountry } from '../../../../international/promo-countries.js';
import { promoDaysLeft } from '../../../../promo/promo-expiration';

const SK_LEAD_COOKIE_ID = '_sk_leadInfo_2';
const SK_EXIT_INTENT_COOKIE_ID = '_sk_exitIntentShowed';
const SK_ECOMMERCE_POP_COOKIE_ID = '_sk_ecommercePopShowed';
const SK_PROMO_EXIT_INTENT_COOKIE_ID = '_sk_promoExitIntentShowed';
const SK_DEVICE_TYPE_COOKIE_ID = '_sk_deviceType';
const SK_SCROLL_POP_COOKIE_ID = '_sk_scrollPopShowed';
const SK_DEMO_SCROLL_POP_COOKIE_ID = '_sk_demoScrollPopShowed';
const SK_QUICKBOOKS_POP_COOKIE_ID = '_sk_quickbooksPopupShowed';

export default {
  props: [
    'name',
    'layout',
    'type',
    'imgClass',
    'scrollpopSelector',
    'isPromo',
    'demoScrollpopSelector'
  ],
  data() {
    return {
      promoExitIntentShowList: [
        ///^\/perfect-pos-solution$/,
        ///^\/perfect-ipad-pos$/,
        ///^\/ipad-pos-system$/,
        ///^\/fast-powerful-simple$/,
      ],
      formStep: 1,
      isCountdownEnabled: true
    };
  },
  computed: {
    getImageClasses() {
      return {
        ['lightbox__image--' + this.imgClass]: this.imgClass
      };
    },

    getLightboxClasses() {
      return {
        video__pause: this.name === 'lightboxVideo',
        [`form-step--${this.formStep}`]: true
      };
    },

    shouldShowLightbox() {
      const ret = this.$root.$data.lightboxToggled === this.name;
      if (ret && (this.type === 'scroll' || this.type === 'demo-scroll')) {
        //force redraw, because when scrolling fast on safari desktop to trigger scrollpop
        //causes freezie pop bug
        setTimeout(() => {
          //have to redraw the entire body and not just the popup because otherwise the snapenage widget
          //is still messed up
          const display = window
            .getComputedStyle(document.body)
            .getPropertyValue('display');
          document.body.style.display = 'none';
          setTimeout(() => {
            document.body.style.display = display;
          }, 10);
        }, 10);
      }
      return ret;
    }
  },
  watch: {
    shouldShowLightbox(newVal) {
      //so we don't have mobile scrolling behind the lightbox
      //only do this for mobile because this adds visible scrolling behind lightbox
      //unfortunately this means there will still be some scrolling visible on iPad or other large screened tablet devices
      if (window.innerWidth >= 768) {
        return;
      }
      if (newVal) {
        document.body.style.position = 'fixed';
      } else {
        document.body.style.position = 'static';
      }
    }
  },
  methods: {
    isSKLead() {
      return !!cookies.get(SK_LEAD_COOKIE_ID);
    },

    bindOnMouseLeave(cb) {
      $('body').on('mouseleave', function(event) {
        cb(event);
      });
    },

    unbindOnMouseLeave() {
      $('body').unbind('mouseleave');
    },

    checkIfLocationInList(list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].test(window.location.pathname)) {
          return true;
        }
      }
      return false;
    },

    setFormStep(stepNum) {
      this.formStep = stepNum;
    },

    setupScrollPop(scrollTriggerSelector, cookieName) {
      if (this.isSKLead()) return;

      const thisScrollPopName = this.name;
      const $window = $(window);
      const $document = $(document);

      const showLightbox = (e) => {
        this.$root.lightboxButtonClick(null, thisScrollPopName);
        this.$root.lightboxToggled = thisScrollPopName;
        cookies.set(cookieName, true, { expires: 7 });
        $(this).unbind(e);
      };

      if (scrollTriggerSelector) {
        const scrollTriggerElement = $(scrollTriggerSelector);
        $window.scroll((e) => {
          const scrollTop = $window.scrollTop();
          const triggerTop = scrollTriggerElement.offset().top;
          if (scrollTop >= triggerTop && scrollTop < triggerTop + 500) {
            showLightbox(e);
          }
        });
      } else {
        $window.scroll((e) => {
          const scrollTop = $window.scrollTop();
          const docHeight = $document.height();
          const winHeight = $window.height();
          const scrollPercent = scrollTop / (docHeight - winHeight);
          if (scrollPercent >= 0.25 && scrollPercent < 0.3) {
            showLightbox(e);
          }
        });
      }
    },

    setupExitIntentPop(cookieName) {
      const cleanUp = () => {
        this.unbindOnMouseLeave();
        cookies.set(cookieName, true, { expires: 7 });
      };

      if (
        cookies.get(SK_DEVICE_TYPE_COOKIE_ID) !== 'desktop' ||
        this.isMobile()
      ) {
        setTimeout(() => {
          if (cookies.get(cookieName) || this.$root.lightboxToggled) return;
          this.$root.lightboxToggled = this.name;
          cleanUp();
        }, 30000);
      } else {
        this.bindOnMouseLeave((event) => {
          if (this.$root.lightboxToggled) return;
          if (this.isSKLead()) {
            this.unbindOnMouseLeave();
            return;
          }
          this.$root.lightboxButtonClick(event, this.name);
          cleanUp();
        });
      }
    },

    setupEcommercePop(cookieName) {
      const cleanUp = () => {
        cookies.set(cookieName, true, { expires: 7 });
      };

      setTimeout(() => {
        if (cookies.get(cookieName) || this.$root.lightboxToggled) return;
        this.$root.lightboxToggled = this.name;
        this.$root.lightboxButtonClick(null, this.name);
        cleanUp();
      }, 15000);
    },

    setupQuickbooksPopup() {
      if (cookies.get(SK_QUICKBOOKS_POP_COOKIE_ID)) return;
      setTimeout(() => {
        if (this.$root.lightboxToggled) return;
        this.$root.lightboxButtonClick(null, this.name, this.prefix, this.optimizelyPrefix);
        cookies.set(SK_QUICKBOOKS_POP_COOKIE_ID, true, { expires: 7 });
      }, 15000);
    },

    isMobile() {
      // device detection
      return (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
          navigator.userAgent
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          navigator.userAgent.substr(0, 4)
        )
      );
    }
  },
  mounted() {
    //wait for country code before showing promo stuff
    countryCode.listenForCountryCode((countryCode) => {
      if (!shouldAllowPromoForCountry(countryCode)) {
        return;
      }
      if (this.isPromo && this.isCountdownEnabled && promoDaysLeft() < 1) {
        return;
      }
      if (this.type === 'scroll' && !cookies.get(SK_SCROLL_POP_COOKIE_ID)) {
        this.setupScrollPop(this.scrollpopSelector, SK_SCROLL_POP_COOKIE_ID);
        return;
      }
      if (
        this.type === 'demo-scroll' &&
        !cookies.get(SK_DEMO_SCROLL_POP_COOKIE_ID)
      ) {
        this.setupScrollPop(
          this.demoScrollpopSelector,
          SK_DEMO_SCROLL_POP_COOKIE_ID
        );
        return;
      }
      if (
        this.type === 'exit-intent' &&
        !cookies.get(SK_EXIT_INTENT_COOKIE_ID)
      ) {
        this.setupExitIntentPop(SK_EXIT_INTENT_COOKIE_ID);
        return;
      }
      if (
        this.type === 'ecommerce-pop' &&
        !cookies.get(SK_ECOMMERCE_POP_COOKIE_ID)
      ) {
        this.setupEcommercePop(SK_ECOMMERCE_POP_COOKIE_ID);
        return;
      }
      if (this.type === 'quickbooks-popup') {
        this.setupQuickbooksPopup();
        return;
      }

      //NEED TO CHECK IF PROMO EXIT INTENT IS TRUE
      const isPromoPage = this.checkIfLocationInList(
        this.promoExitIntentShowList
      );
      if (isPromoPage && !cookies.get(SK_PROMO_EXIT_INTENT_COOKIE_ID)) {
        this.setupExitIntentPop(SK_PROMO_EXIT_INTENT_COOKIE_ID);
      }
    });
  }
};
</script>
